import React, { Component } from 'react'
import { Map, InfoWindow, InfoBox, Marker, GoogleApiWrapper } from 'google-maps-react';

export class MapContainer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { lat, lng, zoom } = this.props;
    return (
      <Map
        google={this.props.google}
        zoom={zoom}
        initialCenter={{
          lat: lat,
          lng: lng
        }}
        style={{width:'80%',height:'600px', margin: '0 auto 0 auto'}}
        >
        <Marker
          title={'TodoPisos S.A.S.'}
          name={'TodoPisos'}
          position={{ lat: lat, lng: lng }} />
      </Map>

    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyAndX6gHhGauGLHaLuYHjFs5mTuLNPsvG4"
})(MapContainer)


// WEBPACK FOOTER //
// ./src/components/mapContainer/MapContainer.jsx